/* src/app/components/login-component/login-component.css */
.login-card {
  max-width: 520px;
  margin: 0 auto;
}
.login-form {
  margin-top: 22px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 18px;
}
.form-group label {
  font-weight: 600;
  color: var(--ink);
}
.form-group input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(212, 175, 55, 0.2);
  background: rgba(13, 11, 10, 0.72);
  color: var(--ink);
  outline: none;
}
.form-group input:focus {
  border-color: rgba(240, 215, 122, 0.7);
  box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.12);
}
.button-row {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}
.validation-text {
  margin-top: 14px;
  color: #ffb0a6;
}
@media (max-width: 768px) {
  .login-card {
    max-width: 100%;
    padding: 0 16px;
  }
  .form-group input {
    padding: 10px 12px;
    font-size: 14px;
  }
  .button-row {
    flex-direction: column;
    gap: 8px;
  }
}
/*# sourceMappingURL=login-component.css.map */
